import DefaultCRUD from '../utils'
const resource = `/main-wire`;

const { get, create } = DefaultCRUD(resource)

export default {
  get,
  create,
}
